export const TEAM_COPY = {
  TITLE: 'Team',
  PANEL_LABEL: 'Team chat and requests',
  ONLINE: (n: number) => `${n} online`,
  SOUNDS_OFF: 'sounds off',
  MUTE: 'Mute notification sounds',
  UNMUTE: 'Unmute notification sounds',
  CHAT: 'Chat',
  REQUESTS: 'Requests',
  OPEN_LABEL: 'Open team chat and requests',
  OPEN_COUNT: (n: number) => `${n} open requests`,
  UNREAD: 'unread messages',
  COLLAPSE: 'Collapse widget',
  DRAG: 'Drag to move',
  MENTION: 'Mention',
  MENTION_LIST: 'Mention a teammate',
  NEED_HELP: 'I need help',
  MESSAGE_PLACEHOLDER: 'Message the team, @ to mention',
  MESSAGE_LABEL: 'Message the team',
  SEND: 'Send message',
  ALSO_REQUEST: (handles: string) => `Also create a request for ${handles}`,
  NO_MESSAGES: 'No messages yet.',
  ACTIVE: (n: number) => `Active (${n})`,
  DONE: (n: number) => `Done (${n})`,
  NO_ACTIVE: 'No active requests. Use “New request” to ask the team for something.',
  NO_DONE: 'Nothing completed yet.',
  NEW_REQUEST: 'New request',
  FILTER_LABEL: 'Show requests',
  WHAT_DO_YOU_NEED: 'What do you need?',
  REQUEST_PLACEHOLDER: 'e.g. @Maria I need some gloves',
  REQUEST_REQUIRED: 'Please describe what you need.',
  SEND_TO_TEAM: 'Send to team',
  CANCEL: 'Cancel',
  CANCEL_REQUEST: 'Close new request',
  CLAIM: "I'm on it",
  ON_IT: (name: string) => `${name} is on it`,
  YOU_ON_IT: "You're on it",
  MARK_DONE: 'Mark done',
  RELEASE: 'Release',
  DONE_BY: (name: string) => `Done by ${name}`,
  FROM: (name: string, time: string) => `From ${name} · ${time}`,
  MENTIONED: 'You were mentioned',
  STATUS: { open: 'Open', in_progress: 'In progress', done: 'Done' },
  ALREADY_TAKEN: 'Someone already took this request.',
  ERROR_TITLE: 'Team',
  SENDING: 'You · Sending…',
  SEND_FAILED: 'Could not send. Check your connection and try again.',
  LOAD_FAILED: 'Could not load. Retrying…',
} as const

export const MESSAGE_MAX_LENGTH = 2000
export const REQUEST_MAX_LENGTH = 500
export const MARK_READ_DELAY_MS = 600
export const LOAD_OLDER_OFFSET_PX = 40
export const NEAR_BOTTOM_PX = 80
export const FRESH_HIGHLIGHT_MS = 2400
export const DING_GAP_MS = 1500
